import { render, staticRenderFns } from "./ClaimsDocuments.vue?vue&type=template&id=4820242c&scoped=true&"
import script from "./ClaimsDocuments.vue?vue&type=script&lang=js&"
export * from "./ClaimsDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsDocuments.vue?vue&type=style&index=0&id=4820242c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4820242c",
  null
  
)

export default component.exports